import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import * as React from "react";
import { InputHelperText, Labeled, useInput } from "react-admin";

const useStyles = makeStyles((theme) => ({
	centeredContainer: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		width: "100%",
	},
	toggleButtonGroup: {
		"& .MuiToggleButton-root": {
			color: theme.palette.secondary.main,
			borderColor: theme.palette.secondary.main,
		},
		"& .Mui-selected": {
			color: theme.palette.common.white,
			borderColor: theme.palette.primary.main,
			backgroundColor: theme.palette.primary.main,
			"&:hover": {
				backgroundColor: theme.palette.primary.dark,
				borderColor: theme.palette.primary.dark,
			},
		},
	},
	errorToggleGroup: {
		"& .MuiToggleButton-root": {
			color: theme.palette.error.main,
			borderColor: theme.palette.error.main,
		},
		"& .Mui-selected": {
			color: theme.palette.error.main,
			borderColor: theme.palette.error.main,
			backgroundColor: theme.palette.error.light,
			"&:hover": {
				backgroundColor: theme.palette.error.dark,
				borderColor: theme.palette.error.dark,
			},
		},
	},
}));

export const ActionToggleButtonGroupInput = ({ helperText, ...props }) => {
	const {
		input: { value, onChange },
		meta: { touched, error, submitError },
	} = useInput(props);
	const classes = useStyles();
	const hasError = touched && (error || submitError);

	const handleChange = (event, newValue) => {
		onChange(newValue);
	};

	return (
		<Box className={classes.centeredContainer}>
			<Labeled source={props.source} resource={props.resource} label={props.label}>
				<Box className={classes.centeredContainer}>
					<ToggleButtonGroup
						value={value}
						exclusive
						onChange={handleChange}
						className={`${classes.toggleButtonGroup} ${hasError ? classes.errorToggleGroup : ""}`}
					>
						{props.choices.map((choice) => (
							<ToggleButton key={choice.id} value={choice.id} aria-label={choice.name} disabled={props.disabled}>
								{choice.name}
							</ToggleButton>
						))}
					</ToggleButtonGroup>
					<Typography
						variant="caption"
						color={hasError ? "error" : undefined}
						style={{ marginTop: 3 }}
					>
						<InputHelperText
							touched={touched}
							error={error || submitError}
							helperText={helperText}
						/>
					</Typography>
				</Box>
			</Labeled>
		</Box>
	);
};
